// 封装到window对象上的公共函数
// console封装
window.Log = function(input) {
    console.log(input);
}

import base from '../base.js'
// 封装到vue原型上的公共函数
export default {
    install(Vue, options) {
        // 存储登录信息
        Vue.prototype.commonSetLocalDataNew = function(key,data) {
            localStorage.setItem(key, data);
        };
        // 获取登录信息
        Vue.prototype.commonGetLocalDataNew = function(key) {
                return localStorage.getItem(key); 
        };
        // 删除登录信息
        Vue.prototype.commondelLocalAllDataNew = function(key) {
          delete localStorage[key];
        };


        Vue.filter("picVideo", function(value) { //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            if (value == 1 || value == 38) {
                return "上传图片、视频"
            } else {
                return "上传图片"
            }
        });
        Vue.filter("lastDayFilter", function(value,msg) { //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
	        if (value == "4070880000") {
	            return "永久"
	        } else {
	            return msg
	        }
    	});
        //生成时间
        Vue.filter("filterBornTime", function(value) {
            if(value == 0){
                return ""
            }
            var out = "0";
            out = getLocalTime(value)
            function getLocalTime(time) {
                var date = new Date(parseInt(time) * 1000);
                var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
                var minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
                var second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
                return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()+" "+hour+":"+minute+":"+second;
            } 
            return out;
        });
        // 时间戳转换YMD
        Vue.filter("turnYMD", function(value) { //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            if (!value || value == 0) {
                return "未知"
            }
            var out = "0";
            out = getLocalTime(value)

            function getLocalTime(time) {
                var date = new Date(parseInt(time) * 1000);
                return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
            }
            return out;
        });
        Vue.filter("phoneFilter", function(value) { //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            if (!!value) {
                return value
            } else {
                return "无"
            }
        });
        Vue.filter("emailFilter", function(value) { //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            if (!!value) {
                return value
            } else {
                return "无"
            }
        });
        Vue.filter("filterRoomName", function(value) { //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            if (!!value) {
                return value
            } else {
                return "无"
            }
        });
        Vue.filter("filterGoodsStatus", function(value) { //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            if(value){
                if(value == 1){
                    return "上架"
                }else{
                    return "下架"
                }
            }else{
                return "异常"
            }
        });
        // 文件导出
        Vue.prototype.commonGetCookies = function() {
            var out = {
                api_local_sess : "",
                api_usagespace : ""
            };
            var name = "local_sess";
            var api_local_sess = "";
            var api_usagespace = "PT_MIX_BZ";
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2){
                api_local_sess = parts.pop().split(";").shift();
            };
            out = {
                api_local_sess : api_local_sess,
                api_usagespace : api_usagespace
            }
            return out
        }
    }
}


// WEBPACK FOOTER //
// ./src/common_js/common.js